// Enums are dictionary of names versus numbers. This is so they work in the same way as C# enums (and other languages) which allow multiple names to have the same number.

let severityEnum = {
    'Minor': 0,
    'Major': 1,
    'Critical': 2
};

export default severityEnum;
